export default "__VITE_ASSET__D5Sb85KS__"